import { RDFertilizer } from '@cibo/core'
import { EventDetailEditorSimple } from '../EventDetail'
import { DetailEditorPropsByYear } from '../types'
import { FertilizerEventSimple } from './FertilizerEvent/FertilizerEventSimple'

export const FertilizerEditorSimple = ({
  fieldModels,
  year,
  name = 'fertilizerEditor',
  requirement,
  filterInputs,
  traitId,
}: DetailEditorPropsByYear) => (
  <EventDetailEditorSimple<RDFertilizer['input']>
    traitId={traitId}
    fieldModels={fieldModels}
    year={year}
    name={name}
    requirement={requirement}
    filterInputs={filterInputs}
    EventComponent={FertilizerEventSimple}
    translationContext="fertilizer"
    defaultEvent={{ date: null, type: '', units: '', method: '' }}
    modal
  />
)
